/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { signUpUserConfig } from '../../config/signUpUser.config';
import axios from 'axios';
import { apiConfig } from '@/config/apiConfig';

export interface VerifyUserProps {
  email: string;
  otp: string;
  headers: any;
}

export interface IVerifyUserMethods extends IPluginMethodMap {
  verifyUser(args: any): Promise<any>;
}

export class VerifyUserService implements IAgentPlugin {
  readonly methods: IVerifyUserMethods;

  constructor() {
    this.methods = {
      verifyUser: this.verifyUser.bind(this),
    };
  }

  async verifyUser(args: VerifyUserProps) {
    console.log(`verifyUser service:`, args);
    try {
      const res = await axios.post(
        `${apiConfig?.rest?.url}${signUpUserConfig?.verifyEP}`,
        {
          email: args?.email,
          otp: args?.otp,
        },
        {
          headers: {
            ...args?.headers,
          },
        }
      );
      if (res?.data) {
        console.log(`user res?.data`, res?.data);
        return res?.data;
      }
      // return true;
    } catch (err: any) {
      console.log(`verifyUser user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
